module.exports = __webpack_public_path__ + "img/support.f0bfa687.svg";